import { render } from "./GibangPinnedNotice.vue?vue&type=template&id=6fc7e776&scoped=true"
import script from "./GibangPinnedNotice.vue?vue&type=script&lang=js"
export * from "./GibangPinnedNotice.vue?vue&type=script&lang=js"

import "./GibangPinnedNotice.vue?vue&type=style&index=0&id=6fc7e776&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc7e776"]])

export default __exports__